import { createAction } from '@reduxjs/toolkit';

export interface ISendViewedPayload {
  type?: string,
  payload: {
    callTime: number,
  },
}

export interface ISendTappedPayload {
  type?: string,
  payload: {
    callTime: number,
  },
}

export const sendViewed = createAction('PROMO/SEND_VIEWED', (): ISendViewedPayload => ({
  payload: {
    callTime: Date.now(),
  },
}));

export const sendTapped = createAction('PROMO/SEND_TAPPED', (): ISendTappedPayload => ({
  payload: {
    callTime: Date.now(),
  },
}));
